import { useEffect, useRef, useState } from "react";

export const useTruncatedText = <T extends HTMLElement = HTMLElement>(dependency?: unknown) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef<T>(null);

  useEffect(() => {
    if (textRef.current) {
      setIsTruncated(textRef.current.scrollHeight > textRef.current.clientHeight);
    }
  }, [dependency]);

  const toggleExpand = () => setIsExpanded((prev) => !prev);

  return {
    textRef,
    isExpanded,
    isTruncated,
    toggleExpand,
    isToggleVisible: isTruncated || isExpanded,
  };
};
